import { Tooltip } from '@mui/material';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  LargeHeart,
  Medicine,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React from 'react';
import DoctorVisit from '../../_components/atoms/Icons/DoctorVisit';
import HospitalBed from '../../_components/atoms/Icons/HospitalBed';
import {
  RiskPatientDataDetails,
  RiskPatientDetailsCardProps,
} from '../../_components/organisms/MedicalHistoryDetails';
import {
  formatDate,
  numberToCurrencyFormatter,
  wrongValuesNeglected,
} from './helper';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { CSSProperties } from '@mui/material/styles';

export interface MemberClaimDetails {
  claim_id: string;
  date: string;
  total_paid_amount: number;
  diagnosis: string[];
  procedure: string;
  medication: string;
  provider: string;
  admissionFlag: string;
  claim_type: string;
}
export interface MemberClaims {
  date?: string;
  details?: MemberClaimDetails[];
}

export interface RiskPatientDetailss {
  member_unique_id: string;
  recent_visit: string;
  chronic_conditions: string[];
  trigger_conditions: string[];
  diagnosis: any[];
  cost: number;
  previous_year_cost: number;
  claimData: MemberClaims[];
}

export interface RiskPatientListData {
  member_unique_id: string;
  recent_visit: string;
  chronic_conditions: string[];
  trigger_conditions: string[];
  cost: number;
  previous_year_cost: number;
}

export interface AllMemberClaims {
  memberId: string;
  claimData: MemberClaims[];
}
export interface IndividualRafScore {
  raf_score: number;
  risk_level: string;
}
export interface DDIScore {
  class: string;
  description: string;
}

export interface ClaimDetailData {
  type: string;
  subType: string;
  lineItemsTable: any[];
  ouputJsonForOuterColumn: any;
  completeColumnJSON: any;
  tableData: any[];
}

export interface CareGapMeasure {
  group: any;
  subCareGroup: SubCareGroup[];
}

export interface CareGapData {
  measureMetCount: number;
  measureNotMetCount: number;
  measure: string;
  measureGroup: string;
  selfImposed: boolean;
}

export interface HealthConditions {
  disease_name: string;
  service_date: string;
}

export interface SubCareGroup {
  title2: string;
  chipText: string;
}
export interface SubCareGroupObject {
  complied: number;
  notComplied: number;
  selfImposed: boolean;
  subCareGroup: SubCareGroup[];
}

export const collapsiblePatientTableHeaderStyles = {
  fontSize: '12px',
  lineHeight: '12px',
  fontWeight: 500,
  color: patientAccessTheme.palette.text.highemphasis,
  margin: '11px 0px 9px 0px',
};

export const collapsiblePatientTableColumns: any[] = [
  {
    name: 'Member ID',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '172px',
    cellPadding: '8px 18px 8px 48px',
  },
  {
    name: 'Recent Visit',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '137px',
  },
  {
    name: 'Chronic Conditions',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '208px',
  },
  {
    name: 'Diagnosis',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '208px',
  },
  {
    name: 'Trigger Conditions',
    align: 'left',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '238px',
  },
  {
    name: 'Cost',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '60px',
  },
  {
    name: 'Previous Year Cost',
    align: 'right',
    cellStyles: collapsiblePatientTableHeaderStyles,
    typographyStyles: collapsiblePatientTableHeaderStyles,
    width: '200px',
    cellPadding: '8px 28px 8px 20px',
  },
];
export const truncateString = (text: string, visibleLength: number) => {
  let str = '';
  if (text?.length > visibleLength) {
    str = text?.substring(0, visibleLength) + '...';
    return str;
  }
  return text;
};
export const getService = (medication: string, procedure: string) => {
  let str = '';
  if (procedure === 'N/A' && medication === 'N/A') {
    str = 'N/A';
    return str;
  }
  if (procedure.length !== 0 && medication === 'N/A') {
    str = procedure;
    return str;
  }
  return medication;
};
export const getStringFromArray = (array: string[]) => {
  let str = '';
  array?.map((item) => {
    if (!wrongValuesNeglected.includes(item) && item?.length !== 0) {
      str = str + item + ' | ';
    }
  });
  return str.length === 0 ? '' : str.slice(0, -3);
};

export const formatEachClaim = (details: MemberClaimDetails[]) => {
  const eachClaimData: RiskPatientDetailsCardProps[] = [];
  details?.forEach((item: any) => {
    const detailsElement: RiskPatientDetailsCardProps = {
      icon: undefined,
      diagnosis: '',
      provider: '',
      claimId: '',
      amountPaid: '',
      claimType: '',
      medication: '',
      avgRatevsCMS: '',
      totalRate: '',
    };
    detailsElement.icon = getMedicalHistoryTimelineIcon(
      item.admissionFlag,
      item.claim_type,
    );
    detailsElement.diagnosis = item.diagnosis;
    detailsElement.provider = item.provider;
    detailsElement.claimId = item.claim_id;
    detailsElement.amountPaid = numberToCurrencyFormatter(
      item.total_paid_amount,
      true,
      2,
    );
    detailsElement.claimType = item.claim_type;
    detailsElement.medication = item.medication;
    detailsElement.avgRatevsCMS =
      item.avgRatevsCMS !== null ? `${item.avgRatevsCMS.toFixed(2)}%` : '—';
    detailsElement.totalRate =
      item.totalRate !== null ? numberToCurrencyFormatter(item.totalRate) : '—';
    eachClaimData.push(detailsElement);
  });
  return eachClaimData;
};

export const getMedicalHistoryTimelineIcon = (
  admissionFlag: string,
  claimType: string,
) => {
  if (claimType === 'rx') {
    return <Medicine style={{ width: '20px', height: '20px' }} />;
  } else {
    if (
      admissionFlag === 'In Patient' ||
      admissionFlag === 'Emergency' ||
      admissionFlag === 'Urgent Care'
    ) {
      return <HospitalBed style={{ width: '20px', height: '20px' }} />;
    } else if (
      admissionFlag === 'Office Visit' ||
      admissionFlag === 'Out Patient'
    ) {
      return <DoctorVisit style={{ width: '20px', height: '20px' }} />;
    } else {
      return <LargeHeart style={{ width: '20px', height: '20px' }} />;
    }
  }
};

export const formatMemberClaimsForMedicalHistory = (
  allMemberClaimData: AllMemberClaims[],
  memberId: string,
) => {
  const memberclaimData: RiskPatientDataDetails[] = [];
  allMemberClaimData.map((item) => {
    if (item.memberId === memberId) {
      item.claimData.forEach((claim) => {
        const element: RiskPatientDataDetails = {
          date: '',
          riskPatientCardDetails: [],
          memberID: '',
        };
        element.date = formatDate(claim.date!, 'Do MMM ,YYYY');
        element.riskPatientCardDetails = formatEachClaim(claim.details!);
        element.memberID = memberId;
        memberclaimData.push(element);
      });
    }
  });
  return memberclaimData;
};

export const formatMemberClaim = (
  claims: MemberClaims[],
  memberId?: string,
) => {
  const memberclaimData: RiskPatientDataDetails[] = [];
  claims.forEach((claim) => {
    const element: RiskPatientDataDetails = {
      date: '',
      riskPatientCardDetails: [],
    };
    element.date = formatDate(claim.date!, 'Do MMM ,YYYY');
    element.riskPatientCardDetails = formatEachClaim(claim.details!);
    element.memberID = memberId;
    memberclaimData.push(element);
  });

  return memberclaimData;
};

export const formatSubheadRiskTier = (risktier: string) => {
  switch (risktier?.replace(' ', '')?.toLowerCase()) {
    case 'tier1':
      return 'High Risk';

    case 'tier2':
      return 'Rising Risk';

    case 'tier3':
      return 'Medium Risk';

    case 'tier4':
      return 'Low Risk';

    case 'tier5':
      return 'No Risk';
    default:
      return 'Risk';
  }
};

export const getTextWithToolTip = (
  text: string[] | string,
  visibleLength: number,
  textStyles?: CSSProperties,
  placement?: any,
) => {
  return (
    <Tooltip
      disableFocusListener
      placement={placement ?? 'top-end'}
      title={
        <Typography fontSize="12px">
          {typeof text === 'string' ? text : getStringFromArray(text)}
        </Typography>
      }
      arrow={true}
    >
      <div style={textStyles}>
        {typeof text === 'string'
          ? truncateString(text, visibleLength)
          : truncateString(getStringFromArray(text), visibleLength)}
      </div>
    </Tooltip>
  );
};
